import { RequestProvider } from '@/shared/providers/request.provider';

import {APP_API, NETWORK_SETTINGS} from '../values/app.values'

class AppServicesClass {

  /* Get Methods */
  public async getInitialData() {
    return RequestProvider.requestPublic('GET', APP_API.INITIAL_DATA, {}, {}, {},
        NETWORK_SETTINGS.http.defaultTimeout);
  }
}

export const AppServices = new AppServicesClass();